import {Component, DestroyRef, inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ErrorModule} from "@app/error/error.module";
import {FilterModule} from "@app/filter/filter.module";
import {GroupByPipe} from "@app/quarantine/shared/pipes/group-by/group-by.pipe";
import {LoadingAnimationComponent} from "@app/loading-animation/loading-animation.component";
import {MedIconResetModule} from "@mk/med-icons";
import {MedPaginationModule} from "@med-ui/med-pagination/med-pagination.module";
import {NgForOf, NgIf} from "@angular/common";
import {
  NoWrapStringWrapperComponent
} from "@app/quarantine/shared/no-wrap-string-wrapper/no-wrap-string-wrapper.component";
import {DataService} from "@app/shared/data.service";
import {Router} from "@angular/router";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {
  QuarantineDocumentPlacement,
  QuarantineDocumentsPlacementRequestInterface, QuarantineDocumentsPlacementResponce
} from "@app/quarantine/intrfaces/quarantine.interface";
import {TokenInterface} from "@app/Interfaces/token.interface";
import {jwtDecode} from "jwt-decode";
import {ContextMenuComponent} from "@app/context-menu/context-menu.component";
import {catchError, debounceTime, Subject, tap} from "rxjs";
import {ReddistributionFilterKeys} from "@app/filter/filter.service";
import {DocumentTypeInterfaces} from "@app/quarantine/intrfaces/quarantine-form.interface";
import {RedistributionApiService} from "@app/redistribution/services/redistribution-api.service";
import {
  RedistributionRequestInterface,
  RedistributionRequestsResponseInterface
} from "@app/redistribution/redistribution.interface";
import {
  RedistributionStatusComponent
} from "@app/redistribution/shared/redistribution-status/redistribution-status.component";

@Component({
  selector: 'app-redistribution-request-table',
  templateUrl: './redistribution-request-table.component.html',
  styleUrls: ['./redistribution-request-table.component.scss'],
  standalone: true,
  imports: [
    ErrorModule,
    FilterModule,
    LoadingAnimationComponent,
    MedIconResetModule,
    MedPaginationModule,
    NgForOf,
    NgIf,
    RedistributionStatusComponent
  ]
})
export class RedistributionRequestTableComponent implements OnInit, OnDestroy {
  
  destroyRef = inject(DestroyRef);
  
  requests: RedistributionRequestInterface[] = [];
  token: TokenInterface = jwtDecode(localStorage['access_token']);
  filters: {[key: string] : string[] | {[p: string]: any} | null} = {};
  errorCode: number | null = null;
  
  @ViewChild('contextMenu') contextMenu!: ContextMenuComponent;
  
  pagination = {
    page: 1,
    perPage: 20,
    totalPages: 0,
    totalElements: 0
  }
  resetFilters: boolean = false;
  isLoading = false;
  $emitRequest = new Subject();
  filterCount = 0;
  allOrganizations: any[] = [];
  
  constructor(
      private dataService: DataService,
      private  router: Router,
      private redistributionApiService: RedistributionApiService
  ) { }
  
  
  ngOnInit() {
    this.subscribeToSubject();
    
    this.dataService.showMyOrganizationValue
        .pipe(
            takeUntilDestroyed(this.destroyRef)
        )
        .subscribe((value) => {
          if (value) {
            this.filters = {
              ...this.filters,
              organizationIds: [...this.dataService.userOrganizationsValue.value.map(el => el['id'])]
            }
          } else {
            delete this.filters['organizationIds'];
            this.filters = {
              ...this.filters
            }
          }
          if(!this.resetFilters) {
            this.pagination.page = 1;
            this.$emitRequest.next({})
          }
        });
    
    this.dataService.allOrganizationsValue.subscribe((value) => {
      let res = [];
      let stash = [...value.data];
      
      while (stash.length > 0) {
        let el = stash.pop();
        res.push(el);
        if (el.children.length > 0) {
          stash.push(...el.children);
        }
      }
      
      
      this.allOrganizations = res;
    })
  }
  
  ngOnDestroy() {
    this.$emitRequest.complete();
  }
  
  getData() {
    this.isLoading = true;
    this.redistributionApiService.getRedistributionRequests(this.filters, {page:  this.pagination.page - 1, size: this.pagination.perPage})
        .pipe(
            catchError(err => {
              this.errorCode = err.status;
              this.isLoading = false;
              return [];
            })
        )
        .subscribe((data: RedistributionRequestsResponseInterface) => {
          this.errorCode = null;
          this.requests = data.content;
          this.pagination.totalPages = data.totalPages;
          this.pagination.totalElements = data.totalElements;
          this.isLoading = false;
        })
  }
  
  onResetFilters() {
    this.resetFilters = true;
    setTimeout(() => {
      this.resetFilters = false;
    }, 100);
    this.filters = {};
    this.pagination.page = 1;
    this.dataService.showMyOrganization = false;
    this.$emitRequest.next({});
  }
  
  onPageChange(page: number) {
    this.pagination.page = page;
    this.$emitRequest.next({});
  }
  
  applyFilters(data: {key: string, payload: string[] | {[p: string]: any}}) {
    this.pagination.page = 1;
    
    if (data.payload.length > 0) {
      this.filters = {
        ...this.filters,
        // @ts-ignore
        [data.key]: data.payload
      }
    } else {
      // @ts-ignore
      delete this.filters[data.key];
      this.filters = {
        ...this.filters
      }
    }
    this.$emitRequest.next({});
  }
  
  onRowClick(id:number): void {
    if (!(['moz', 'doz'].includes(this.dataService.userRoleValue.value))) {
      return;
    }
    
    this.router.navigate(['redistributions/requests/' + id]);
  }
  
  subscribeToSubject() {
    this.$emitRequest
        .pipe(
            takeUntilDestroyed(this.destroyRef),
            debounceTime(400),
            tap(() => {
              this.filterCount = Object.keys(this.filters).length;
            })
        )
        .subscribe(() => {
          this.getData();
        });
  }
  
  getOrganisationName(id: number) {
    return this.allOrganizations.find(el => el.id === id)?.fullName || id;
  }

}
